import React, { useState, useEffect } from "react";
import { Container, Card, Button, Form } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { get, post } from "../../helpers/RequestHelper";

function Topic() {
  const history = useHistory();
  const { subjectId, chapterId } = useParams();
  const [chapter, setChapter] = useState({});
  const [topic, setTopic] = useState({name:"",description:""});

  useEffect(() => {
    getChapterData();
  }, []);

  async function getChapterData() {
    try {
      const chapterData = await get(
        "/api/admin/subject/" + subjectId + "/chapter/" + chapterId
      );
      setChapter(chapterData);
    } catch (err) {
      setChapter({});
    }
  }
  
  function handleBlur(event) {
    setTopic({
      ...topic,
      [event.target.id]: ( event.target.value ).trim(),
    });
  }

  
  function handleChange(event) {
    setTopic({
      ...topic,
      [event.target.id]: event.target.value,
    });
  }

  function goBack() {
    history.push(`/admin/subject/${subjectId}/chapter/${chapterId}/topic`);
  }

  async function handleSubmit(event) {
    event.preventDefault();
    try {
      await post(`/api/admin/chapter/${chapterId}/topic`, {
        ...topic,
        parent_id: chapterId,
      });
      goBack();
    } catch (err) {}
  }

  return (
    <>
      <Container fluid="md">
        <Card style={{ marginTop: "50px" }}>
          <Card.Header>
            <h4 className="float-left">Create Topic in {chapter.name}</h4>
          </Card.Header>
          <Form onSubmit={handleSubmit}>
            <Card.Body>
              <>
                <Form.Group controlId="name" onChange={handleChange} onBlur={handleBlur}>
                  <Form.Label
                    className="float-left"
                    style={{ marginLeft: "5px", marginTop: "5px" }}
                  >
                    Name
                  </Form.Label>
                  <Form.Control
                    as="input"
                    placeholder="Enter topic name"
                    required
                    value={topic.name}
                  />
                </Form.Group>
                <Form.Group controlId="description" onChange={handleChange} onBlur={handleBlur}>
                  <Form.Label
                    className="float-left"
                    style={{ marginLeft: "5px", marginTop: "20px" }}
                  >
                    Enter Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="3"
                    placeholder="Description"
                    required
                    value={topic.description}
                  />
                </Form.Group>
              </>
            </Card.Body>
            <Card.Footer>
              <Button
                type="button"
                onClick={goBack}
                className="float-left"
                style={{ color: "white" }}
              >
                Back
              </Button>
              &nbsp;
              <Button variant="primary" type="submit">
                Update
              </Button>
            </Card.Footer>
          </Form>
        </Card>
      </Container>
    </>
  );
}
export default Topic;
